
































































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import { ClaimEnum } from '@/services/ClaimEnum';

@Component
export default class UploadSingleDocument extends Vue {
    @Prop({
        required: true
    })
    product: any;

    @Prop({
        required: true
    })
    documentType: string;
    fileName: string = '';
    countryAuthorities: any = [];
    countryAuthoritySelected: string = null;
    cultures: any = [];
    languages: any = [];
    languageSelected: string = null;
    otherLanguageSelected: string = null;
    documentTypes: any = [];
    documentTypeSelected: string = null;
    documentUploaded: boolean = false;

    uploading: boolean = false;
    uploadPerc: number = 0;
    isAuthorized: boolean = false;
    general: any = {};
    selectedSingleDocument: any = null;
    chunkSize: number = 300;
    idSession: string = "";
    mounted() {
        this.general = General;
        this.getCountries();
        this.getLanguagesComplete();
        this.getCultures();
        this.getDocumentTypes();
        this.isAuthorized = General.CheckAuthorization(ClaimEnum.CanUploadDocument);
    }
    updateProgress(e: any) {
        this.uploadPerc = e;
    }
    showSuccessAlert(sessionId: any) {
        let app = this;
        app.idSession = sessionId;
        app.uploadPerc = 100;
        app.documentUploaded = true;

    }
    getFileName(fileName: string) {
        this.fileName = fileName;
    }
    close() {
        this.$bvModal.hide('upload-single-document-modal');
    }
    getCultures() {
        let app = this;
        let apiUrl = General.GetApiUrl('/api/culture/getcultures');
        axios({
            method: 'get',
            url: apiUrl,
            responseType: 'json',
            withCredentials: true
        }).then(function (response) {
            let outputData = new Array();
            response.data.forEach(function (item: any) {
                outputData.push(item);
            });
            app.cultures = outputData;

        }).catch(error => {
            General.HandleError(error, app);
        });

    }

    getCountries() {
        let app = this;
        let apiUrl = General.GetApiUrl('/api/culture/getcountries?emptyCountriesPolicy=0&type=COUNTRY_AUTHORITY');
        axios({
            method: 'get',
            url: apiUrl,
            responseType: 'json',
            withCredentials: true
        }).then(function (response) {
            let outputData = new Array();
            response.data.forEach(function (item: any) {
                outputData.push({
                    value: item.idCountry,
                    text: item.name
                });
            });
            app.countryAuthorities = outputData;
        }).catch(error => {
            General.HandleError(error, app);
        });
    }
    getLanguages(idCountry: any) {
        var languages = new Array();
        if (idCountry != null) {
            for (let i = 0; i < this.cultures.length; i++) {
                if (this.cultures[i].country.idCountry == idCountry) {
                    languages.push({
                        value: this.cultures[i].language.idLanguage,
                        text: this.cultures[i].language.name
                    });
                }
            }
            languages.push({
                value: 'OTHER',
                text: 'OTHER LANGUAGE'
            });
        }
        return languages;
    }
    getOtherLanguages(idCountry: any) {
        let languages = new Array();

        if (idCountry != null) {
            let languagesExclused = this.getLanguages(idCountry);

            for (let i = 0; i < this.languages.length; i++) {


                if (!this.findLanguage(this.languages[i].idLanguage, languagesExclused)) {
                    languages.push({
                        value: this.languages[i].idLanguage,
                        text: this.languages[i].name
                    });
                }

            }


        }

        return languages;
    }
    findLanguage(idLanguage: string, languages: any[]): boolean {
        for (let i = 0; i < languages.length; i++) {

            if (languages[i].value == idLanguage) return true;
        }
        return false;
    }
    getLanguagesComplete() {
        let app = this;
        let apiUrl = General.GetApiUrl('/api/culture/getLanguages?emptyLanguagesPolicy=0');
        axios({
            method: 'get',
            url: apiUrl,
            responseType: 'json'
        }).then(function (response) {
            let outputData = new Array();
            response.data.forEach(function (item: any) {
                outputData.push(item);
            });
            app.languages = outputData;
        }).catch(error => {
            General.HandleError(error, app);
        });
    }
    getDocumentTypes() {
        let app = this;

        //app.documentTypes.push(
        //    { value: app.documentType, text: app.documentType }
        //);

        if (app.documentType == "PDS") {
            app.documentTypes.push(
                { value: "PDS", text: " PDF - visible internally in PLI and externally" });
            app.documentTypes.push(
                { value: "PDSDOCX", text: "World - visible only to Product manager with the role to upload PDS" }
            );
        }
        else if (app.documentType == "PDSDOCX") {
            app.documentTypes.push(
                { value: "PDSDOCX", text: "World - visible only to Product manager with the role to upload PDS" });
            app.documentTypes.push(
                { value: "PDS", text: " PDF - visible internally in PLI and externally" }
            );
        }

        app.documentTypeSelected = app.documentTypes[0].value;
    }
    getSingleDocumentUrl(idDocument: any) {
        return General.GetApiUrl('/api/document/DownloadDocumentById?documentId=' + idDocument);
    }
    checkMandatoryFields(): string {
        var errors = new Array();
        if (this.countryAuthoritySelected == null) errors.push('Country Authority / Region is mandatory');
        if (this.getLanguageSelected() == null) errors.push('Language is mandatory');
        if (this.documentUploaded != true) errors.push('Document is mandatory');

        if (errors.length == 0) return null;

        return errors.join('<br>');
    }
    getLanguageSelected(): string {
        let languageSelected = (this.languageSelected == 'OTHER') ? this.otherLanguageSelected : this.languageSelected;
        return languageSelected;
    }
    saveSingleDocument() {


        let fieldValidation = this.checkMandatoryFields();

        if (fieldValidation == null) {
            this.saveSingleDocumentDo();

        } else {
            General.showAlertDangerAsHTML(fieldValidation, this);
        }
    }
    saveSingleDocumentDo() {
        this.uploading = true;

        let formData = new FormData();

        formData.append('documentType', this.documentTypeSelected);
        formData.append('idproduct', this.product.idProduct);
        formData.append('idcountry', this.countryAuthoritySelected);
        formData.append('idlanguage', this.getLanguageSelected());
        formData.append('idSession', this.idSession);
        let app = this;
        axios({
            method: 'post',
            url: General.GetApiUrl('/api/document/uploadsingledocument'),
            data: formData,
            withCredentials: true
        })
            .then(function (response) {
                app.uploading = false;

                if (response.data.errors.length > 0) {
                    let error = "";
                    for (let i = 0; i < response.data.errors.length; i++) {
                        error += response.data.errors[i] + "<br/>";
                    }
                    General.showAlertDangerAsHTML(error, app);
                }
                else {

                    General.showAlertSuccess("Upload Complete", app);
                    app.uploadComplete();
                }
            })
            .catch(error => {
                app.reset();
                General.HandleError(error, app);
            });

    }
    uploadComplete() {
        this.close();
        this.$emit('complete');
    }
    reset() {
        this.uploading = false;

    }
}
